import { useAppSelector } from 'appState/store'
import { useState } from 'react'
import { FaBuilding, FaFileCsv } from 'react-icons/fa'
import { ObModal } from '@outbound-ai/ursa'

import styled from 'styled-components'
import { longTextToSmall } from 'utils/helper'
import { FileShareFilesUpload } from './FileShareFilesUpload'

interface IProps {
  show: boolean
  hide: () => void
}

export const FileShareUploadModal = ({ show, hide }: IProps) => {
  const { currentTenant } = useAppSelector((state) => state.auth)
  const [claimFileName, setClaimFileName] = useState<string | null>(null)

  const titleWithSub = () => {
    return (
      <TitleContainer>
        <h2>Upload Claim File</h2>
        <div className="sub-container">
          {claimFileName && (
            <div className="file-name">
              <FaFileCsv className="csv-icon" /> {longTextToSmall(claimFileName, 30, 60)}
            </div>
          )}

          <div className="tenant-container">
            <FaBuilding className="tenant-icon" /> {currentTenant && longTextToSmall(currentTenant, 9, 18)}
          </div>
        </div>
      </TitleContainer>
    )
  }

  return (
    <Div>
      <ObModal
        show={show}
        close={() => hide()}
        title={titleWithSub()}
        customSize="large"
        size="lg"
        height={'auto'}
        dataTestId="FileShareFileUploadTestId"
      >
        <FileShareFilesUpload
          setFileName={(fileName: string | null) => setClaimFileName(fileName)}
          closeModal={() => hide()}
        />
      </ObModal>
    </Div>
  )
}

const Div = styled.div`
  .down-arrow {
    width: 1rem !important;
    height: 1rem !important;
    margin-bottom: 0 !important;
    color: ${({ theme }) => theme.colors.neutral.lightest} !important;
  }
  .upload-file-btn {
    height: 2rem;
    font-size: 0.875rem;
    font-weight: 600;
  }
`

const TitleContainer = styled.div`
  h2 {
    margin-bottom: 0.25rem;
    font-size: 1.25rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary.neutral};
  }
  .do-not-repeat-icon {
    width: 24px;
    height: 24px;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-left: 12px;
    padding: 4px;
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.warning.neutral};
    border: solid 1px ${({ theme }) => theme.colors.grey.lighter};
    background-color: ${({ theme }) => theme.colors.grey.lightest};

    .retweet-icon {
      font-size: 0.875rem;
    }
  }
  .sub-container {
    display: flex;
    align-items: center;

    .file-name,
    .tenant-container {
      display: flex;
      align-items: center;
      font-size: 0.875rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: left;
      color: ${({ theme }) => theme.colors.grey.dark};
    }
    .file-name {
      margin-right: 0.75rem;
    }
    .csv-icon,
    .tenant-icon {
      font-size: 0.75rem;
      margin-right: 0.125rem;
      margin-bottom: 0.125rem;
    }
  }
`
